import type { Action } from "../../actions/types";
import { AnimationStatus } from "../../actions/animation/types";

export type StoreState = AnimationStatus;

export const initialState = "entering";

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "SET_ANIMATION_STATUS":
      return action.data;
    case "SET_SCREEN_NAME":
      return "entering";
    default:
      return state;
  }
}
